import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";
import { PostQuote } from "@/components/blog/PostQuote";

export function ImpactoTraficoSection() {
  return (
    <PostSection id="impacto-trafico" title="Impacto en el tráfico orgánico">
      <p>
        El impacto principal de los AI Overviews no es la eliminación del tráfico orgánico, sino su 
        <strong> redistribución</strong>. Se está creando una dinámica de «el ganador se lleva más», 
        donde las fuentes citadas ganan visibilidad y las no citadas la pierden.
      </p>

      <h3 id="ganadores-citados" className="text-xl font-bold text-white mt-8 mb-4">
        Ganadores: fuentes citadas (+20-40% CTR)
      </h3>
      <PostHighlight>
        Las fuentes citadas dentro de un AI Overview experimentan un aumento del CTR del 20 al 40%, 
        además de un impulso significativo en autoridad de marca.
      </PostHighlight>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Más clics:</strong> aparecer como fuente citada genera más tráfico que estar en posición 3-5 sin citación</li>
        <li><strong>Efecto compuesto:</strong> ser citado consistentemente construye señales de confianza que mejoran futuros rankings</li>
        <li><strong>Autoridad de marca:</strong> el usuario asocia tu sitio como fuente experta y fiable</li>
      </ul>

      <h3 id="perdedores-no-citados" className="text-xl font-bold text-white mt-8 mb-4">
        Perdedores: posiciones 3-10 no citadas (-15-25% CTR)
      </h3>
      <p>
        El efecto negativo se concentra en las <strong>posiciones medias</strong> que no logran ser referenciadas 
        por el AI Overview:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Posiciones 3-10:</strong> pierden entre un 15% y un 25% de clics orgánicos</li>
        <li><strong>Posiciones 1-2:</strong> se mantienen relativamente estables</li>
        <li><strong>Consultas long-tail:</strong> las más afectadas, ya que el AI Overview responde completamente</li>
      </ul>

      <PostQuote 
        text="Ya no se trata solo de estar en la primera página. Se trata de ser la fuente que Google cita en su respuesta de IA."
        author="Análisis SEO 2026"
      />
    </PostSection>
  );
}
